import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { itemsActions } from "../../store/itemStore";
import styles from "./Reply.module.css";
const Reply = () => {
  const dispatch = useDispatch();
  const { type, message } = useSelector((state) => state.items.reply);

  useEffect(() => {
    let timeOut;
    if (message) {
      timeOut = setTimeout(() => {
        dispatch(
          itemsActions.onChangeReply({
            type: null,
            message: "",
          })
        );
      }, 2500);
    }
    return () => {
      clearTimeout(timeOut);
    };
  }, [message, dispatch]);
  return <>{type !== null && message && <p className={styles[type]}>{message}</p>}</>;
};

export default Reply;
